import { FC } from "react";
import { PdfData } from "@/models/pdfData";
import { useNavigate } from "react-router-dom";
import { Box, Container } from "@mui/material";
import { generatePdf } from "@/pdf/challengeProtocolPdfGenerator";
import { useImageDataUrlContext } from "@context/ImageDataUrlContext";
import AppVersion from "../components/AppVersion";
import GamesList from "../components/games-list/GamesList";
import { Views } from "@/models/gameGeneral";
import FabSpeeddial from "@components/buttons/FabSpeeddial";

const GamesOverviewPage: FC = () => {
  const { dataUrls } = useImageDataUrlContext();
  const navigate = useNavigate();

  const onCreateGame = (game: PdfData, destination: Views) => {
    navigate(
      `/game/${game.scope}/${game.samsId}/${destination === "challenge" ? "challenge-view" : "referee-tablet"}`,
    );
  };

  const onCreateEmpty = () =>
    window.open(generatePdf(dataUrls).output("bloburl"));

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
      height={"100%"}
      overflow={"hidden"}
    >
      <Container fixed maxWidth={"xl"} sx={{ py: 2, overflow: "auto" }}>
        <GamesList />
      </Container>

      <AppVersion showAlwaysOnState={false} />
      <FabSpeeddial onCreateGame={onCreateGame} onCreateEmpty={onCreateEmpty} />
    </Box>
  );
};

export default GamesOverviewPage;
